module.exports = __webpack_public_path__ + "media/images/e-kvitok/arrow_left_white-d998ab29321307859764c434e3020e4d.svg";